module.exports = __webpack_public_path__ + "static/media/playstore.ab486b0c.svg";